import type { HttpClient } from '../../../types/api';
import type { PostSearchCodeResponse } from '../types';

export const postSearchCode = async (
  serialCode: string,
  oemServiceId: string,
  httpClient: HttpClient,
): Promise<PostSearchCodeResponse> => {
  return await httpClient.post<PostSearchCodeResponse>('/user/v1/campaign/search-code', {
    body: JSON.stringify({
      oem_service_id: oemServiceId,
      serial_code: String(serialCode).toLocaleUpperCase(),
    }),
  });
};
